﻿import { createFileRoute } from "@tanstack/react-router";
import { ProdutosPage } from "@/paginas/pg_franquia/franquia-produtos";

export const Route = createFileRoute("/_authenticated/produtos")({
  validateSearch: (
    s: Record<string, unknown>,
  ): {
    editar?: string | undefined;
    voltarInsumo?: string | undefined;
    voltarConsumo?: string | undefined;
  } => ({
    editar: typeof s["editar"] === "string" ? (s["editar"] as string) : undefined,
    voltarInsumo: typeof s["voltarInsumo"] === "string" ? (s["voltarInsumo"] as string) : undefined,
    voltarConsumo:
      typeof s["voltarConsumo"] === "string" ? (s["voltarConsumo"] as string) : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Produtos e receitas — Milky Moo Palmares" },
      { name: "description", content: "Cadastro dos produtos e dos insumos usados em cada um." },
      { property: "og:title", content: "Produtos e receitas — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Cadastro dos produtos e dos insumos usados em cada um.",
      },
    ],
  }),
  component: ProdutosPage,
});
